import Vue from 'vue';
import VueSelect from 'vue-select';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vue-select/dist/vue-select.css';
import './assets/styles/main.css';
import { t } from './common/lang/i18n';
import { AuthStorage } from './common/utils';

Vue.config.productionTip = false;

// if (process.env.VUE_APP_CONST_ENV === 'dev') {
//   import('vconsole').then((module) => {
//     const VConsole = module.default;
//     new VConsole();
//   });
// }
// 埋点 -设置 eventSessionId
const { eventId, eventSessionId } = router.currentRoute.query;
if (eventId || eventSessionId) {
  AuthStorage.set('sls_eventSessionId', eventId || eventSessionId);
}

Vue.component('VSelect', VueSelect);

Vue.prototype.$t = t;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
